import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@mademine/components';
import { ReactComponent as IconClose } from '../../assets/icon-close.svg';
import styles from './style.module.less';
var Guide = function (_a) {
    var onClose = _a.onClose, children = _a.children;
    return (_jsx("div", { className: styles['guide-wrap'], children: _jsxs("div", { className: styles.guide, children: [_jsx("div", { className: styles['guide-content'], children: children }), _jsxs("div", { className: styles['guide-footer'], onClick: onClose, children: [_jsx("div", { className: styles['guide-footer-divider'] }), _jsx("div", { className: styles['guide-footer-close'], children: _jsx(Icon, { size: 30, color: "white", children: _jsx(IconClose, {}) }) })] })] }) }));
};
export default Guide;
